import domainsRegistry from "./data/permission-domains.json" with { type: "json" };
const permissionToDomainIndex = buildPermissionToDomainIndex();
function buildPermissionToDomainIndex() {
    const index = new Map();
    for (const [domain, def] of Object.entries(domainsRegistry)) {
        for (const permission of def.permissions) {
            index.set(permission, domain);
        }
    }
    return index;
}
export function getDomainForPermission(permission) {
    return permissionToDomainIndex.get(permission) ?? null;
}
export function getDomainFulfilmentFeatures(domain) {
    return domainsRegistry[domain]?.fulfilmentFeatures ?? [];
}
export function getDomainEntityType(domain) {
    return domainsRegistry[domain]?.entityType ?? null;
}
//# sourceMappingURL=domains.js.map